/**
 * Analysis-overlay sources + layers — empty GeoJSON sources that the
 * isochrone, buffer, and measure tools push features into. Mounted once
 * on map load.
 */
export function setupOverlaySources(map) {
  // Isochrones
  map.addSource('iso', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'iso-fill', type: 'fill', source: 'iso',
    paint: { 'fill-color': ['get', 'color'], 'fill-opacity': 0.18 },
  });
  map.addLayer({
    id: 'iso-line', type: 'line', source: 'iso',
    paint: { 'line-color': ['get', 'color'], 'line-width': 2, 'line-dasharray': [3, 2] },
  });

  // Buffers
  map.addSource('buf', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'buf-fill', type: 'fill', source: 'buf',
    paint: { 'fill-color': '#04648d', 'fill-opacity': 0.12 },
  });
  map.addLayer({
    id: 'buf-line', type: 'line', source: 'buf',
    paint: { 'line-color': '#04648d', 'line-width': 2, 'line-dasharray': [4, 2] },
  });

  // Emerging hotspot result polygons (hex cells colored by trend category)
  map.addSource('emerging-hotspot', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'emerging-hotspot-fill', type: 'fill', source: 'emerging-hotspot',
    paint: {
      'fill-color':   ['coalesce', ['get', 'color'], '#999'],
      'fill-opacity': 0.55,
    },
  });
  map.addLayer({
    id: 'emerging-hotspot-line', type: 'line', source: 'emerging-hotspot',
    paint: {
      'line-color':   ['coalesce', ['get', 'color'], '#999'],
      'line-width':   0.5,
      'line-opacity': 0.7,
    },
  });

  // Origin-Destination flow lines
  map.addSource('od-flow', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'od-flow-line', type: 'line', source: 'od-flow',
    paint: {
      // Width scales with the per-feature `width` property (set client-side
      // from the magnitude column). Color is the chosen ramp's mid hue.
      'line-color':   ['coalesce', ['get', 'color'], '#04648d'],
      'line-width':   ['coalesce', ['get', 'width'], 1.5],
      'line-opacity': 0.75,
    },
    layout: { 'line-cap': 'round', 'line-join': 'round' },
  });
  map.addSource('od-flow-points', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'od-flow-pt', type: 'circle', source: 'od-flow-points',
    paint: {
      'circle-radius': ['case', ['==', ['get', 'kind'], 'origin'], 4, 5],
      'circle-color':  ['case', ['==', ['get', 'kind'], 'origin'], '#04648d', '#98c262'],
      'circle-stroke-color': '#ffffff',
      'circle-stroke-width': 1.5,
      'circle-opacity': 0.95,
    },
  });

  // Measurements (distance lines, area polygons)
  map.addSource('measure', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  map.addLayer({
    id: 'measure-fill', type: 'fill', source: 'measure',
    filter: ['==', ['geometry-type'], 'Polygon'],
    paint: { 'fill-color': '#04648d', 'fill-opacity': 0.18 },
  });
  map.addLayer({
    id: 'measure-line', type: 'line', source: 'measure',
    filter: ['!=', ['geometry-type'], 'Point'],
    paint: { 'line-color': '#04648d', 'line-width': 2.5, 'line-dasharray': [4, 3] },
  });
  map.addLayer({
    id: 'measure-pts', type: 'circle', source: 'measure',
    filter: ['==', ['geometry-type'], 'Point'],
    paint: {
      'circle-radius': 5,
      'circle-color': '#04648d',
      'circle-stroke-color': '#fff',
      'circle-stroke-width': 2,
    },
  });
}
